import script from "./hmgl.vue?vue&type=script&setup=true&lang=js"
export * from "./hmgl.vue?vue&type=script&setup=true&lang=js"

import "./hmgl.vue?vue&type=style&index=0&id=2f109444&lang=less"

const __exports__ = script;

export default __exports__